import React, { FC, useMemo } from 'react';
import {
  CandidateLayout,
  DEFAULT_OG_IMAGES,
  SEO_COMMON,
} from '../../layout/candidate/CandidateLayout';
import { SearchPanel } from './components/SearchPanel';
import stylesModule from './Search.module.less';
import { SearchContextProvider, SearchQuery, useSearchContext } from './SearchContext';
import { Grid } from 'antd';
import { SearchPageLayout } from './components/SearchPageLayout';
import { JobPostResponseData } from '../../models/JobPostModals';
import { NextSeo } from 'next-seo';
import Utils from '../../utils/Utils';
import { JobDetailsPage } from './components/JobDetailsCard';
import Config from '../../config';
import { SSRPage } from '../../components/SSRPage/SSRPage';
import { useCookies } from 'react-cookie';
import { useCachedData } from '../../connection/CacheContext';

const styles: any = stylesModule;

type Props = {
  query: any;
  results: JobPostResponseData;
};

const SearchContent: FC = () => {
  const search = useSearchContext();
  const bp = Grid.useBreakpoint();
  const cache = useCachedData();

  const [cookies] = useCookies(['banner-closed']);
  const [title, canonical, openGraph] = useMemo(() => {
    let tt = `Jobs in Sri Lanka | Job Vacancies in ${Utils.moment().format('YYYY')} | Careers360`;
    let canonical = `${Config.frontendUrl}/jobs`;
    let openGraph = {
      title: tt,
      url: canonical,
      description:
        'Careers360 is the most popular job portal for jobs in Sri Lanka, and to find out the best top job vacancies in Sri Lanka to your career next growth step',
      images: DEFAULT_OG_IMAGES,
    };
    if (search.selected) {
      tt = `${search.selected?.jobTitle} | ${tt}`;
      const value = search.selected;
      const locations = cache.getLocationString(value?.locationData ?? []);
      canonical = `${Config.frontendUrl}/jobs/${Utils.normalizeURIComponent(
        search.selected.jobTitle!,
      )}/${search.selected.jobPostId}`;
      openGraph = {
        title: [
          value.jobTitle,
          value.recruiterName,
          // (value?.enumData?.locationData ?? []).join(', '),
          locations,
          (value?.enumData?.jobCategory ?? []).join(', '),
        ].join(' | '),
        description: [
          `Want to know about the top ${(value?.enumData?.jobCategory ?? []).join(
            ', ',
          )} jobs in Sri Lanka? Visit the Top Jobs listing page to get all the latest information on ${
            value.jobTitle
          }. Find more about jobs in Sri Lanka.`,
        ].join(' | '),
        url: `${Config.frontendUrl}/jobs/${Utils.normalizeURIComponent(value.jobTitle!)}/${
          value.jobPostId
        }`,
        images: [
          {
            url: `${Config.fileStoreUrl}/files/images/recruiter/job/${value.recruiterId}.jpeg`,
            width: 1200,
            height: 630,
          },
        ],
      };
    }
    return [tt, canonical, openGraph];
  }, [cache, search.selected]);
  const showBanner = false; //cookies['banner-closed'] !== 'yes';

  return (
    <CandidateLayout
      className={styles.article}
      showBanner={showBanner}
      navbarAddon={bp.md && <SearchPanel />}
      title={
        <NextSeo
          title={openGraph.title} //New Job Vacancies in Sri Lanka for Immediate Hiring | Careers360
          description={openGraph.description} //Elevate your journey with the best job listings in Sri Lanka. Immediate hiring is available, seize the opportunity and apply now with Careers360.
          additionalMetaTags={[
            {
              name: 'keywords',
              content:
                'Jobs in Sri Lanka | Careers360 , New job vacancies ,Best jobs in Sri Lanka , New job vacancy in Sri Lanka , Best paying jobs in Sri Lanka',
            },
          ]}
          canonical={canonical}
          openGraph={openGraph}
          {...SEO_COMMON}
        />
      }>
      {!bp.md && <SearchPanel />}
      <SearchPageLayout showBanner={showBanner} />
      {/*<div className={styles.bestWeb}>*/}
      {/*  <a*/}
      {/*    rel="noreferrer"*/}
      {/*    href="https://www.vote.bestweb.lk/site/www_careers360_lk/"*/}
      {/*    target="_blank">*/}
      {/*    <img src="https://www.bw2022.lk/vote4us.png" alt="logo" width="100%" height="100%" />*/}
      {/*  </a>*/}
      {/*</div>*/}
    </CandidateLayout>
  );
};

export const SearchPage2: FC<Props> = (props) => {
  return (
    <SearchContextProvider query={props.query} results={props.results} resetQuery={true}>
      <SearchContent />
    </SearchContextProvider>
  );
};

type SearchSwitchProps = {
  pageType: 'search' | 'view';
  pageProps: any;
};

export const SearchSwitch: SSRPage<SearchSwitchProps> = (props) => {
  const { pageProps, pageType } = props;
  if (pageType === 'search') {
    return <SearchPage2 {...pageProps} />;
  }
  return <JobDetailsPage {...pageProps} />;
};

SearchSwitch.getInitialProps = async (connection, query) => {
  const {
    from,
    size,
    search,
    sector,
    jobCategory,
    workplaceType,
    company,
    location,
    country,
    salary_type,
    SalaryUp,
    SalaryDown,
    currency,
    onlyCurrency,
    graduate,
    recent,
    posted,
    jobType,
    jobFunction,
    experienceLevel,
    results,
    id,
  } = query;
  const arrVal = (val: any) => (val ? (Array.isArray(val) ? val : [val]) : undefined);
  const strVal = (val: any) => (val ? (val as string) : undefined);
  const numVal = (val: any) => (val ? +val : undefined);

  let jobId = undefined;
  if (Array.isArray(id) && id.length >= 2) {
    jobId = id[1];
  }

  const sq: SearchQuery = {
    from: numVal(from),
    size: numVal(size),
    search: strVal(search),
    sector: arrVal(sector),
    jobCategory: arrVal(jobCategory),
    workplaceType: arrVal(workplaceType),
    company: arrVal(company),
    location: arrVal(location),
    country: arrVal(country),
    salary_type: strVal(salary_type),
    SalaryUp: numVal(SalaryUp),
    SalaryDown: numVal(SalaryDown),
    currency: strVal(currency),
    onlyCurrency: onlyCurrency === 'true',
    graduate: !!graduate,
    recent: recent === undefined ? undefined : recent === 'true',
    posted: strVal(posted),
    jobId: strVal(jobId),
    jobType: arrVal(jobType),
    jobFunction: arrVal(jobFunction),
    experienceLevel: arrVal(experienceLevel),
    results: strVal(results),
  };
  const entries = Object.entries(sq).filter((e) => !!e[1]);
  const sqf = Object.fromEntries(entries);
  console.log(jobId);
  if (jobId && results !== 'show') {
    try {
      const { jobPost } = await connection.get(`job-post/byid/${jobId}`);
      return {
        pageType: 'view',
        pageProps: { value: jobPost, query: entries.length > 0 ? sqf : null },
      };
    } catch (e) {
      console.log('Err');
    }
  }

  try {
    const result = await connection.get(`job-post`, sqf);
    delete sqf.jobId;
    return { pageType: 'search', pageProps: { query: sqf, results: result } };
  } catch (e) {
    return { pageType: 'search', pageProps: { query: sqf } };
  }
};
